import { memo } from 'react';
import { ButtonGroup, HStack, styled, Center } from '@cad-arc';
import { useMeasurements } from '../hooks/use-measurements';
import { MapView } from '../constructors';
import { IconButtonControl } from './styled';
import { EsriMapShortcuts } from './esri-map-shortcuts';
import { Tooltip } from '~/common/components/tooltip';

const ToolsContainer = styled('div')`
    z-index: 1;
    position: absolute;
    height: 64px;
    bottom: 4px;
    right: 60px;
`;

type MapMeasuresToolsProps = {
    mapView?: MapView;
};

export const MapTools = memo(({ mapView }: MapMeasuresToolsProps) => {
    const { activeTool, measureArea, measureDistance, clear, setCurrentTool } = useMeasurements(
        mapView
    );

    return (
        <ToolsContainer>
            <Center height="64px">
                <HStack spacing="10px" height="64px">
                    <EsriMapShortcuts />
                    {activeTool && (
                        <>
                            <Tooltip overlay="Clear Measurement" mouseEnterDelay={0.5}>
                                <IconButtonControl
                                    size="md"
                                    icon="TrashCan"
                                    aria-label="Clear Measurement"
                                    onClick={() => setCurrentTool(activeTool)}
                                />
                            </Tooltip>
                            <Tooltip overlay="Exit Tool" mouseEnterDelay={0.5}>
                                <IconButtonControl
                                    size="md"
                                    icon="CloseX"
                                    aria-label="Exit Tool"
                                    onClick={clear}
                                />
                            </Tooltip>
                        </>
                    )}
                    <ButtonGroup isAttached>
                        <Tooltip overlay="Measure Distance" mouseEnterDelay={0.5}>
                            <IconButtonControl
                                size="md"
                                icon="ExpandWindow"
                                aria-label="Measure Distance"
                                className={activeTool === 'distance' ? 'active' : undefined}
                                onClick={measureDistance}
                            />
                        </Tooltip>
                        <Tooltip overlay="Measure Area" mouseEnterDelay={0.5}>
                            <IconButtonControl
                                size="md"
                                icon="Geofence"
                                aria-label="Measure Area"
                                className={activeTool === 'area' ? 'active' : undefined}
                                onClick={measureArea}
                            />
                        </Tooltip>
                    </ButtonGroup>
                </HStack>
            </Center>
        </ToolsContainer>
    );
});
